export default { plannerStyle: {
  retryLoad: '重新加载',
  applyRevision: '确认修改',
  localRevision: '修改保存在本机，再次发布后生效。',
  editRevision: '修改款式',
  republish: '再次发布',
  unpublished: '修改未发布',
  discard: '放弃修改',
  discardRevision: '放弃本次未发布的修改？已发布资料保持不变。',
  leaveRevision: '修改尚未发布。保留本机草稿并离开？',
  keepAndLeave: '保留草稿并离开',
  usedSizes: '尺码 {p0} 已用于下游资料，请保留或先由对应担当调整。原资料未删除。',
  usedColors: '颜色 {p0} 已用于下游资料，请保留或先由对应担当调整。原资料未删除。',
  title: '款式资料', create: '新建款号', drafts: '建款草稿', noDrafts: '暂无建款草稿', unnumbered: '款号待填写', styleNm: '品名', season: '年度季节', draft: '草稿', published: '已生成设计任务', publishedTasks: '查看已发布款式与委托书',
  source: '资料来源', manual: '手工建款', existing: '已有款号', fair: '订货资料', basic: '款式资料', order: '订货资料', people: '人员', main: '大货', reorder: '加单', editPrice: '修改售价', editOrder: '编辑款式与订货资料', openSheet: '查看委托书',
  publish: '发布款式', deleteDraft: '删除草稿', deleteConfirm: '删除此建款草稿？', notFound: '款式草稿不存在', alreadyPublished: '款式已发布，请打开款式资料。', brandFixed: '品牌不可更改。',
  invalidStyle: '款号须对应当前品牌和有效小分类，请先核对。', duplicateStyle: '该款号已有资料，请打开已有款式。', publishRequired: '发布前请补齐品名、年度季节、颜色尺码及六名负责人。',
  priceRequired: '待商品企划填写售价', quantityRequired: '待商品企划补齐订货数量，合计须大于0', dateRequired: '待填写入库要求日', invalidDate: '请填写有效日期', invalidMonth: '上市月格式为 YYYY-MM', invalidYear: '年度填写四位数字', invalidPrice: '售价填写非负金额，最多两位小数', invalidQuantity: '数量填写有效非负整数', invalidMatrix: '颜色尺码重复或超出本款范围',
  pending: '待填写', pendingHint: '空格为待填写，0表示未下单。', rangeFirst: '先设置颜色与尺码范围', zero: '空格填0', import: '导入款式资料', paste: '粘贴数量表格', uploadCsv: '选择CSV / TSV文件', template: '下载建款模板', preview: '预览', apply: '应用预填',
  importTooLarge: '表格超过2MB，请缩小后导入。', invalidTable: '请检查表头、列数和引号。', importColumns: '需包含款号、品名、品牌、年度、季节、颜色、尺码、数量列。', importInconsistent: '同款资料不一致，请一次导入一个款式。',
  styleCharacters: '款号只能包含大写字母和数字',
  styleLength: '正式款号须为10位',
  styleBrand: '款号前两位须与当前品牌一致',
  styleCategory: '款号第3–4位须为当前品牌的有效小分类',
  fieldRequired: '请填写此项',
  categoryUnavailable: '分类暂未加载，请稍后重试',
  copyQuantityTemplate: '复制模板到Excel',
  templateCopied: '已复制模板',
  templateInInput: '模板已放入输入框，可复制到Excel填写。',
  quantityPasteHint: '复制模板到Excel填写数量，再将包含颜色、尺码表头的整张表复制并粘贴到下方。空格表示待填写，0表示未下单。',
  previewSummary: '{cells}个数量格 · 合计{total}件',
  duplicateColumn: '表头“{column}”重复，请保留一列。',
  rowColumns: '第{row}行有{actual}列，表头为{expected}列。请用Excel复制或逗号分隔。',
  noSizeColumns: '缺少尺码列，请使用本款数量模板。',
  unknownSize: '尺码“{column}”不在本款范围内。',
  unknownColor: '第{row}行颜色“{color}”不在本款范围内。',
  duplicateColor: '第{row}行颜色“{color}”重复。',
  quantityCell: '第{row}行、{column}列须填写非负整数或留空。',
  totalMismatch: '第{row}行合计为{total}，数量格合计为{sum}。请核对或移除合计列。',
  styleDateCode: "款号年度、季节或月别代码不符合该品牌规则",
  styleYearMismatch: "年度与款号第5位不一致",
  styleSeasonMismatch: "季节与款号第6位不一致",
  styleMonthMismatch: "上市月与款号年度、月别代码不一致",
  styleTailCode: "款号末三位不符合该品牌的系列、性别或序号规则",
  invalidSeason: "请从当前季节选项中选择",
  unknownMasterSize: "请从本品牌品类的尺码表中选择",
  unknownMaterialColor: "请从面料颜色表中选择E或B开头的代码",
  styleCorrectionBlocked: "此款已尝试传送SAP，款号不可在原单修改",
  styleCorrectionRetry: "款号资料已更新，请刷新后重新传送",
  correctStyleCode: "纠正款号",
  correctionHint: "保留委托书编号和已填写内容。",
  fields: { brandCd: '品牌', styleCd: '款号', styleNm: '品名', originalStyleNo: '原款号', genderCd: '性别', productYear: '年度', season: '季节', salesMonth: '上市月', finalGrade: '商品等级', businessType: '业务类型', productType: '商品类型', styleKind: '款号种类', characteristic: '特性参数', productionCategory: '生产品类', productionType: '生产类型', mdpType: 'MDP类型', mdpStartDate: 'MDP开始日期', salePrice: '售价CNY', receivingDueDate: '入库要求日期' },
}, plannerBatch: {
  publishing: '正在发布…',
  location: '{p0} 第{p1}行：{p2}',
  useBatch: '请从批量记录中核对并发布；不创建的款号可取消勾选。',
  "title": "批量新建款号",
  "fileTitle": "选择文件",
  "fileHint": "款号生成、企划数量两张表；最多100款，5MB。",
  "chooseFile": "选择 Excel",
  "template": "下载模板",
  "noFile": "尚未选择",
  "summary": "共 {n} 款 · {errors} 款待核对 · 已选 {selected} 款",
  "all": "全部",
  "errors": "待核对",
  "empty": "选择填写好的模板，核对新款信息。",
  "sourceRow": "款号生成 · 第 {row} 行",
  "range": "颜色 × 尺码",
  "check": "核对结果",
  "ready": "可发布",
  "review": "核对",
  "doneReview": "完成核对",
  "moreIssues": "还有 {n} 项待核对",
  "sourceFields": "查看来源字段",
  "row": "行号",
  "save": "保存整批草稿",
  "publish": "发布所选款号",
  "atomicHint": "所选款全部通过后发布；失败时保留草稿。",
  "saved": "整批草稿已保存。",
  "published": "发布完成，相关同事可在任务中查看。",
  "publishConfirm": "发布所选 {n} 款，交给相关同事继续填写？",
  "replaceConfirm": "重新上传会替换尚未保存的信息，继续？",
  "leaveConfirm": "还有未保存的批量修改。离开前请保存整批草稿。",
  "leave": "离开",
  "batches": "批量草稿与发布记录",
  "fileLimit": "文件不能超过5MB，请减少款数后重新上传。",
  "fileFormat": "请选择真实的 .xls 或 .xlsx Excel 文件。",
  "layout": "请使用模板中的两张表，并保留表头及列顺序。",
  "capacity": "每批最多100款、1500条颜色数量行。请拆分文件，不要删除必要数据。",
  "formula": "请将公式转换为值，并修正错误单元格后重新上传。",
  "duplicateRows": "文件包含重复款号或重复颜色尺码，请检查。",
  "orphanQuantity": "数量表有款号未在款号表中出现，请核对两张表。",
  "notNewStyle": "本入口只用于新款，生产次数应为00。",
  "rangeConflict": "数量表的颜色或尺码不在款式范围内，请核对两张表。",
  "orderConflict": "同款不同颜色的售价、入库日期或生产类型不一致，请核对。",
  "priceConflict": "两张表的售价不同，请确认售价。",
  "quantity": "数量应为不超过2147483647的非负整数。",
  "peopleConflict": "同一岗位填写了不同人员，请选择实际负责人。",
  "categoryConflict": "来源分类与款号分类不同，请核对款号。",
  "publishBlocked": "所选款还有待核对信息，本批未发布。",
  "acceptCurrent": "按当前填写确认",
  "retry": "重试",
  "sourcePage": "来源记录第 {page} 页",
  "sourcePrevious": "上一页",
  "sourceNext": "下一页",
  "templateHint": "款号表从第5行填写，数量表从第2行填写。颜色、尺码和工号使用文本格式。"
} };
